import { ApiNames, ApiProxy, ApiRequest } from '@lib/api/apiProxy';

export class PhotosQueryApi {
  private static apiProxy = ApiProxy.getInstance();
  private static apiName = ApiNames.Photos;

  public static getUploadUrl(
    fileName: string,
    fileType?: string,
    bucket?: BucketType,
    category?: string
  ): Promise<UploadUrl> {
    const baseEndpoint = `/requestSignedUrl`;
    const queryParams = {
      fileName,
      ...(bucket ? { bucket } : {}),
      ...(category ? { category } : {}),
      ...(fileType
        ? { s3Fields: JSON.stringify({ 'Content-Type': fileType }) }
        : {}),
    };
    const queryParamsString = new URLSearchParams(queryParams).toString();
    const endpoint = `${baseEndpoint}?${queryParamsString}`;

    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }

  public static getUserPhotos(
    userId: number,
    compressed?: boolean
  ): Promise<UserPhoto[]> {
    let endpoint = `/casting/user/${userId}`;
    if (compressed) endpoint += '?version=compressed';
    return this.apiProxy.execute(new ApiRequest(this.apiName, endpoint));
  }
}
